import { fetchAllRetailerStores } from '@/services/stores'

/**
 * Mutation types of the store
 */
const mutationTypes = {
  FETCHING: 'FETCHING',
  FETCHED: 'FETCHED'
}

/**
 * Initial state
 */
const state = {
  loading: false,
  retailerStores: undefined
}

/**
 * Getters
 */
const getters = {}

/**
 * Actions
 */
const actions = {
  fetchAllRetailerStores({ commit }) {
    commit(mutationTypes.FETCHING)

    return fetchAllRetailerStores()
      .then((retailerStores) => {
        commit(mutationTypes.FETCHED, retailerStores)
      })
      .catch((err) => {
        console.log(err)
        commit(mutationTypes.FETCHED)
      })
  }
}

/**
 * Mutations
 */
const mutations = {
  [mutationTypes.FETCHING](state) {
    state.loading = true
  },

  [mutationTypes.FETCHED](state, retailerStores) {
    state.retailerStores = retailerStores
    state.loading = false
  }
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state
}
